import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue'
import { useRouter } from 'vue-router';
import PopupVideo from '@/components/popup-video.vue';

type Emits = { 
    (e: 'progress'): void
    (e: 'back'):void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ready-setup',
  emits: ["progress", "back"],
  setup(__props, { expose, emit }: { emit: ({ 
    (e: 'progress'): void
    (e: 'back'):void
}), expose: any, slots: any, attrs: any }) {
  expose();



const showVideo = ref(false)

const router = useRouter();
const goTo = (route: string) =>{
    router.push(route)
}
const moveBack = () =>{
    emit('back')
}


const __returned__ = { emit, showVideo, router, goTo, moveBack, ref, useRouter, PopupVideo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})